var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: {
            callback: _vm.visibilityChanged,
            once: true,
          },
          expression:
            "{\n\t\tcallback: visibilityChanged,\n\t\tonce: true,\n\t}",
        },
      ],
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.selectTheme.apply(null, arguments)
        },
      },
    },
    [
      _vm.isVisible
        ? _c("div", { staticClass: "imageNode" }, [
            _c("img", {
              attrs: { src: _vm.themeModel.icon },
              on: { load: _vm.imageLoaded },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "textNode" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.themeName) + "\n\t"),
      ]),
      _vm._v(" "),
      _vm.selectedTheme && _vm.themeModel.id == _vm.selectedTheme
        ? _c("div", { staticClass: "selectedIcon" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("\n\t\t\tcheck\n\t\t"),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }